import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const SolicitudCargaManual = React.lazy(
  () => import("../screean/services/solicitud-carga-manual")
);
export function solicitudCargaManual() {
  return (
    <Route
      path="/solicitud-carga-manual"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <SolicitudCargaManual />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
